(function () {
  const BODY_CLASS = 'sticky-atc-pdp-visible';
  const CHECK_SVG =
    '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initStickyAtc() {
    const sticky = document.querySelector('.sticky-atc-pdp');
    if (!sticky || sticky.dataset.initialized === 'true') return;

    const productPage =
      sticky.closest('product-page') || document.querySelector('product-page');
    if (!productPage) return;

    const mainAtcAnchor =
      productPage.querySelector('.product__cart-actions-holder') ||
      productPage.querySelector('.product__cart-actions') ||
      productPage.querySelector('product-form');
    const mainAtcButton =
      productPage.querySelector('.product__cart-actions .product__add-to-cart') ||
      productPage.querySelector('.product__add-to-cart') ||
      productPage.querySelector('.add-to-cart-btn');
    const mainAtc = mainAtcAnchor || mainAtcButton;
    if (!mainAtc) return;

    sticky.dataset.initialized = 'true';

    const sectionId = sticky.dataset.sectionId;
    const variantsMount = sticky.querySelector('[data-sticky-variants]');
    const stickyBtn = sticky.querySelector('[data-sticky-atc-trigger]');
    const stickyBtnText = stickyBtn?.querySelector('.add-to-cart__text');

    const productVariants = productPage.querySelector(
      `product-variants[data-id="${sectionId}"]`
    );

    let syncing = false;
    let openDropdown = null;
    let isStickyShown = false;
    let visibilityRaf = 0;

    function getMainVariantsRoot() {
      const inPicker = productPage.querySelector(
        'product-variants .product__variants'
      );
      if (inPicker) return inPicker;

      const inSwatches = productPage.querySelector(
        '.variant-swatches-container .product__variants'
      );
      if (inSwatches) return inSwatches;

      return productPage.querySelector('.product__variants');
    }

    function getStickyVariantsRoot() {
      return variantsMount?.querySelector('.product__variants') || null;
    }

    function getMainInputById(inputId) {
      if (!inputId) return null;
      const root = getMainVariantsRoot();
      if (!root) return null;

      if (typeof CSS !== 'undefined' && CSS.escape) {
        return root.querySelector('#' + CSS.escape(inputId));
      }

      return Array.from(root.querySelectorAll('.product-variant__input')).find(
        (input) => input.id === inputId
      );
    }

    function getOptionLabel(mainGroup) {
      const nameEl = mainGroup.querySelector('.product-variant__name');
      if (!nameEl) return 'Shade';

      const text = nameEl.textContent
        .replace(/:-.*$/, '')
        .replace(/^select\s+/i, '')
        .trim();

      return text || 'Shade';
    }

    function getSelectedMainItem(mainGroup, groupIndex) {
      const checked = mainGroup.querySelector('.product-variant__input:checked');
      if (checked) return checked.closest('.product-variant__item');

      const selectedLabel = mainGroup.querySelector(
        '.product-variant__label.selected-var'
      );
      if (selectedLabel) return selectedLabel.closest('.product-variant__item');

      const variantOption = productVariants?.currentVariant?.options?.[groupIndex];
      if (variantOption) {
        for (const item of mainGroup.querySelectorAll('.product-variant__item')) {
          const input = item.querySelector('.product-variant__input');
          if (input?.value === variantOption) return item;
        }
      }

      const shadeSpan = mainGroup.querySelector('.concealer-selected-shade span');
      const shadeValue = shadeSpan?.textContent?.trim();
      if (shadeValue) {
        for (const item of mainGroup.querySelectorAll('.product-variant__item')) {
          const input = item.querySelector('.product-variant__input');
          if (input?.value === shadeValue) return item;
        }
      }

      return mainGroup.querySelector('.product-variant__item');
    }

    function updateShadeLabelInGroup(group, value) {
      if (!group || value == null) return;
      group.querySelectorAll('.concealer-selected-shade span').forEach((el) => {
        el.textContent = value;
      });
    }

    function updateShadeLabelsFromVariant(variant) {
      if (!variant) return;
      const values = variant.options || [];
      const roots = [getMainVariantsRoot(), getStickyVariantsRoot()].filter(Boolean);
      roots.forEach((root) => {
        root.querySelectorAll('.product-variant').forEach((group, index) => {
          if (values[index] != null) {
            updateShadeLabelInGroup(group, values[index]);
          }
        });
      });
    }

    function getSwatchSource(label) {
      if (!label) return null;
      return (
        label.querySelector('.tb-shade-swatch') ||
        label.querySelector('.tb-combo-swatch-pair > span') ||
        label.querySelector('span[aria-hidden="true"]:not(.tb-combo-swatch-pair)') ||
        label.querySelector('span')
      );
    }

    function applyAllSwatchesFromLabel(label, targetEl) {
      if (!label || !targetEl) return;
      const pair = label.querySelector('.tb-combo-swatch-pair');
      const swatches = pair
        ? pair.querySelectorAll('.tb-shade-swatch, span')
        : [];

      if (swatches.length > 1) {
        targetEl.hidden = false;
        targetEl.classList.remove('sticky-atc-pdp__shade-swatch--empty');
        targetEl.removeAttribute('style');
        targetEl.classList.add('sticky-atc-pdp__shade-trigger-swatch--pair');
        targetEl.innerHTML = '';
        swatches.forEach((source) => {
          const chip = document.createElement('span');
          chip.className = 'sticky-atc-pdp__shade-swatch';
          chip.setAttribute('aria-hidden', 'true');
          const inlineStyle = source.getAttribute('style');
          if (inlineStyle) chip.setAttribute('style', inlineStyle);
          targetEl.appendChild(chip);
        });
        return;
      }

      targetEl.classList.remove('sticky-atc-pdp__shade-trigger-swatch--pair');
      targetEl.innerHTML = '';
      applySwatchFromLabel(label, targetEl);
    }

    function applySwatchFromLabel(label, targetEl) {
      const source = getSwatchSource(label);
      if (!source) {
        targetEl.hidden = true;
        targetEl.classList.add('sticky-atc-pdp__shade-swatch--empty');
        targetEl.removeAttribute('style');
        return;
      }

      targetEl.hidden = false;
      targetEl.classList.remove('sticky-atc-pdp__shade-swatch--empty');
      const inlineStyle = source.getAttribute('style');
      if (inlineStyle) {
        targetEl.setAttribute('style', inlineStyle);
      } else {
        targetEl.style.backgroundImage = source.style.backgroundImage;
        targetEl.style.backgroundColor = source.style.backgroundColor;
      }
    }

    function createSwatchEl(label) {
      const el = document.createElement('span');
      el.className = 'sticky-atc-pdp__shade-swatch';
      el.setAttribute('aria-hidden', 'true');
      applyAllSwatchesFromLabel(label, el);
      return el;
    }

    function closeAllDropdowns() {
      variantsMount
        ?.querySelectorAll('.sticky-atc-pdp__shade-dropdown.is-open')
        .forEach((dropdown) => {
          dropdown.classList.remove('is-open');
          const trigger = dropdown.querySelector('.sticky-atc-pdp__shade-trigger');
          const menu = dropdown.querySelector('.sticky-atc-pdp__shade-menu');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (menu) menu.hidden = true;
        });
      openDropdown = null;
    }

    function toggleDropdown(dropdown) {
      const isOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (isOpen) return;

      const trigger = dropdown.querySelector('.sticky-atc-pdp__shade-trigger');
      const menu = dropdown.querySelector('.sticky-atc-pdp__shade-menu');
      dropdown.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (menu) menu.hidden = false;
      openDropdown = dropdown;
    }

    function updateDropdownFromGroup(dropdown, mainGroup, groupIndex) {
      if (!dropdown || !mainGroup) return;

      const selectedItem = getSelectedMainItem(mainGroup, groupIndex);
      if (!selectedItem) return;

      const label = selectedItem.querySelector('.product-variant__label');
      const input = selectedItem.querySelector('.product-variant__input');
      const triggerSwatch = dropdown.querySelector(
        '.sticky-atc-pdp__shade-trigger-swatch'
      );
      const triggerName = dropdown.querySelector('.sticky-atc-pdp__shade-trigger-name');

      if (triggerSwatch) applyAllSwatchesFromLabel(label, triggerSwatch);
      if (triggerName && input) triggerName.textContent = input.value;

      dropdown.querySelectorAll('.sticky-atc-pdp__shade-option').forEach((opt) => {
        const isSelected = opt.dataset.mainInputId === input?.id;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function buildShadeDropdown(stickyGroup, mainGroup, groupIndex) {
      const container = stickyGroup.querySelector('.product-variant__container');
      if (!container) return null;

      const nameEl = stickyGroup.querySelector('.product-variant__name');
      if (nameEl) nameEl.hidden = true;

      const mainItems = mainGroup.querySelectorAll('.product-variant__item');
      if (!mainItems.length) return null;

      const optionLabel = getOptionLabel(mainGroup);
      const dropdown = document.createElement('div');
      dropdown.className = 'sticky-atc-pdp__shade-dropdown';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'sticky-atc-pdp__shade-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      const triggerSwatch = document.createElement('span');
      triggerSwatch.className = 'sticky-atc-pdp__shade-trigger-swatch';
      triggerSwatch.setAttribute('aria-hidden', 'true');

      const triggerText = document.createElement('span');
      triggerText.className = 'sticky-atc-pdp__shade-trigger-text';

      const triggerLabel = document.createElement('span');
      triggerLabel.className = 'sticky-atc-pdp__shade-trigger-label';
      triggerLabel.textContent = optionLabel;

      const triggerName = document.createElement('span');
      triggerName.className = 'sticky-atc-pdp__shade-trigger-name';

      triggerText.append(triggerLabel, triggerName);

      const chevron = document.createElement('span');
      chevron.className = 'sticky-atc-pdp__shade-chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML =
        '<svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

      trigger.append(triggerSwatch, triggerText, chevron);

      const menu = document.createElement('ul');
      menu.className = 'sticky-atc-pdp__shade-menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      mainItems.forEach((mainItem) => {
        const mainInput = mainItem.querySelector('.product-variant__input');
        const label = mainItem.querySelector('.product-variant__label');
        if (!mainInput || !label) return;

        const option = document.createElement('li');
        option.className = 'sticky-atc-pdp__shade-option';
        option.setAttribute('role', 'option');
        option.dataset.mainInputId = mainInput.id;
        option.setAttribute('aria-selected', 'false');

        const optionSwatch = createSwatchEl(label);
        const optionName = document.createElement('span');
        optionName.className = 'sticky-atc-pdp__shade-option-name';
        optionName.textContent = mainInput.value;

        const optionCheck = document.createElement('span');
        optionCheck.className = 'sticky-atc-pdp__shade-option-check';
        optionCheck.innerHTML = CHECK_SVG;

        option.append(optionSwatch, optionName, optionCheck);
        menu.appendChild(option);
      });

      dropdown.append(trigger, menu);
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');
      stickyGroup.appendChild(dropdown);

      updateDropdownFromGroup(dropdown, mainGroup, groupIndex);
      return dropdown;
    }

    function buildStickyVariants() {
      const mainRoot = getMainVariantsRoot();
      if (!mainRoot || !variantsMount) return;

      closeAllDropdowns();
      variantsMount.innerHTML = mainRoot.outerHTML;
      const stickyRoot = getStickyVariantsRoot();
      if (!stickyRoot) return;

      stickyRoot.querySelectorAll('input').forEach((input) => {
        input.removeAttribute('name');
        input.removeAttribute('id');
        input.setAttribute('tabindex', '-1');
        input.setAttribute('aria-hidden', 'true');
      });

      stickyRoot.querySelectorAll('label').forEach((label) => {
        label.removeAttribute('for');
        label.setAttribute('aria-hidden', 'true');
        label.hidden = true;
      });

      const mainGroups = mainRoot.querySelectorAll('.product-variant');
      const stickyGroups = stickyRoot.querySelectorAll('.product-variant');

      stickyGroups.forEach((stickyGroup, index) => {
        buildShadeDropdown(stickyGroup, mainGroups[index], index);
      });
    }

    function syncStickyDropdowns() {
      const mainRoot = getMainVariantsRoot();
      if (!mainRoot) return;

      const mainGroups = mainRoot.querySelectorAll('.product-variant');
      variantsMount
        ?.querySelectorAll('.sticky-atc-pdp__shade-dropdown')
        .forEach((dropdown, index) => {
          updateDropdownFromGroup(dropdown, mainGroups[index], index);
        });
    }

    function syncStickyFromMain() {
      if (syncing) return;
      syncing = true;
      syncStickyDropdowns();
      syncing = false;
    }

    function applyMainVariantSelection(mainInput) {
      const value = mainInput.value;
      const mainItem = mainInput.closest('.product-variant__item');
      const mainGroup = mainInput.closest('.product-variant');

      mainGroup?.querySelectorAll('.product-variant__label').forEach((label) => {
        label.classList.remove('selected-var');
      });
      mainItem?.querySelector('.product-variant__label')?.classList.add('selected-var');

      mainInput.checked = true;
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));

      updateShadeLabelInGroup(mainGroup, value);
      requestAnimationFrame(syncStickyFromMain);
    }

    function selectMainVariantFromOption(optionEl) {
      const mainInput = getMainInputById(optionEl.dataset.mainInputId);
      if (!mainInput) return;

      applyMainVariantSelection(mainInput);
      closeAllDropdowns();
    }

    function syncAtcButtonFromMain() {
      if (!stickyBtn) return;
      const sourceBtn = mainAtcButton || mainAtc;
      stickyBtn.classList.toggle('disabled', sourceBtn.classList.contains('disabled'));
      stickyBtn.disabled = sourceBtn.classList.contains('disabled');
      const sourceText = sourceBtn.querySelector?.('.add-to-cart__text');
      if (stickyBtnText && sourceText) {
        stickyBtnText.textContent = sourceText.textContent;
      }
    }

    function updateBodyPadding() {
      if (!isStickyShown) {
        document.documentElement.style.removeProperty('--sticky-atc-pdp-height');
        return;
      }

      const height = Math.ceil(sticky.offsetHeight);
      if (height > 0) {
        document.documentElement.style.setProperty(
          '--sticky-atc-pdp-height',
          `${height}px`
        );
      }
    }

    function setVisible(visible) {
      if (visible === isStickyShown) return;
      isStickyShown = visible;

      if (!visible) closeAllDropdowns();

      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle(BODY_CLASS, visible);

      if (visible) {
        syncStickyFromMain();
        updateBodyPadding();
        requestAnimationFrame(() => requestAnimationFrame(updateBodyPadding));
      } else {
        document.documentElement.style.removeProperty('--sticky-atc-pdp-height');
      }
    }

    if (typeof ResizeObserver !== 'undefined') {
      const bodyPaddingObserver = new ResizeObserver(() => {
        if (isStickyShown) updateBodyPadding();
      });
      bodyPaddingObserver.observe(sticky);
    }

    window.addEventListener('resize', () => {
      if (isStickyShown) updateBodyPadding();
    });

    buildStickyVariants();
    syncStickyFromMain();
    syncAtcButtonFromMain();

    [100, 400, 1000].forEach((delay) => {
      setTimeout(syncStickyFromMain, delay);
    });

    variantsMount?.addEventListener('click', (e) => {
      const option = e.target.closest('.sticky-atc-pdp__shade-option');
      if (option && variantsMount.contains(option)) {
        e.preventDefault();
        e.stopPropagation();
        selectMainVariantFromOption(option);
        return;
      }

      const trigger = e.target.closest('.sticky-atc-pdp__shade-trigger');
      if (trigger && variantsMount.contains(trigger)) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown(trigger.closest('.sticky-atc-pdp__shade-dropdown'));
      }
    });

    variantsMount?.addEventListener('keydown', (e) => {
      const option = e.target.closest('.sticky-atc-pdp__shade-option');
      if (option && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        selectMainVariantFromOption(option);
        return;
      }

      const trigger = e.target.closest('.sticky-atc-pdp__shade-trigger');
      if (trigger && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        toggleDropdown(trigger.closest('.sticky-atc-pdp__shade-dropdown'));
      }

      if (e.key === 'Escape') closeAllDropdowns();
    });

    document.addEventListener('click', (e) => {
      if (!variantsMount?.contains(e.target)) closeAllDropdowns();
    });

    productPage.addEventListener('change', (e) => {
      if (!e.target.matches('.product-variant__input')) return;
      if (variantsMount?.contains(e.target)) return;

      const group = e.target.closest('.product-variant');
      updateShadeLabelInGroup(group, e.target.value);
      syncStickyFromMain();
    });

    productPage.addEventListener('click', (e) => {
      if (variantsMount?.contains(e.target)) return;
      const label = e.target.closest('.product-variant__label');
      if (!label) return;

      requestAnimationFrame(syncStickyFromMain);
    });

    if (productVariants) {
      productVariants.addEventListener('VARIANT_CHANGE', (e) => {
        if (e.target?.currentVariant) {
          updateShadeLabelsFromVariant(e.target.currentVariant);
        }
        syncStickyFromMain();
        syncAtcButtonFromMain();
      });
    }

    const mainAtcObserver = new MutationObserver(syncAtcButtonFromMain);
    mainAtcObserver.observe(mainAtcButton || mainAtc, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      subtree: true,
      childList: true,
    });

    function evaluateStickyVisibility() {
      if (visibilityRaf) return;
      visibilityRaf = requestAnimationFrame(() => {
        visibilityRaf = 0;

        const rect = mainAtc.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const showBuffer = 72;
        const hideBuffer = 48;

        const notReachedYet = rect.top >= vh;
        const inView = isStickyShown
          ? rect.top < vh - hideBuffer && rect.bottom > hideBuffer
          : rect.top < vh - showBuffer && rect.bottom > hideBuffer;

        setVisible(!notReachedYet && !inView);
      });
    }

    evaluateStickyVisibility();
    window.addEventListener('scroll', evaluateStickyVisibility, { passive: true });
    window.addEventListener('resize', evaluateStickyVisibility, { passive: true });

    stickyBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const sourceBtn = mainAtcButton || mainAtc;
      if (sourceBtn.disabled || sourceBtn.classList.contains('disabled')) return;
      sourceBtn.click();
    });

    if (productVariants?.currentVariant) {
      updateShadeLabelsFromVariant(productVariants.currentVariant);
      syncStickyFromMain();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', initStickyAtc);
})();
